import { MantineSize } from '@mantine/core';
import { ThemeIcon } from 'src/design/atoms/ThemeIcon';
import { Tooltip } from 'src/design/atoms/Tooltip';
import { IconChartBarOff } from '@tabler/icons-react';
import React from 'react';
import { WbsTreeData } from 'src/routes/Jobs/WBS/components/types';
import { hasProgressManagedDescendant } from 'src/utils';

export interface IMixedProgressIndicatorProps {
  node: WbsTreeData;
  size?: MantineSize;
}

/** Warns on a non-progress-managed WBS folder that has a progress-managed descendant, since its quantity roll-up excludes that descendant; renders nothing otherwise. */
export const MixedProgressIndicator: React.FC<IMixedProgressIndicatorProps> = ({
  size = 'sm',
  node,
}) => {
  // Only meaningful on folders that themselves are not progress-managed but
  // contain at least one progress-managed descendant: their rolled-up totals
  // exclude those descendants and users need to know.
  if (node.isLeaf || node.progressManaged) return null;
  if (!hasProgressManagedDescendant(node)) return null;

  return (
    <Tooltip
      label="Quantity roll-up excludes progress-managed children (hours still summed)"
      withArrow
    >
      <ThemeIcon color="gray" size={size} variant="light">
        <IconChartBarOff />
      </ThemeIcon>
    </Tooltip>
  );
};
